exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert[data-v-9652c738]{margin-bottom:var(--spacer-base)}\n", ""]);

// exports
